import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Receipt, FileText, DollarSign, CreditCard, Calculator } from 'lucide-react';

const navItems = [
  { label: 'Quotations', href: '/app/sales/quotations', icon: FileText },
  { label: 'Proforma Invoices', href: '/app/sales/proforma-invoices', icon: DollarSign },
  { label: 'Payment Schedule', href: '/app/sales/milestones', icon: CreditCard },
  { label: 'Tax Invoices', href: '/app/sales/tax-invoices', icon: Receipt },
  { label: 'Estimate Invoices', href: '/app/sales/estimate-invoices', icon: Calculator },
];

export function AccountingSubNav() {
  const location = useLocation();

  return (
    <nav className="relative bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
      <div className="max-w-full mx-auto px-4">
        <div className="flex min-w-0 items-center gap-1 overflow-x-auto pb-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.href ||
              (item.href === '/app/sales/tax-invoices' && location.pathname.startsWith('/app/sales/tax-invoices')) ||
              (item.href === '/app/sales/proforma-invoices' && (location.pathname.startsWith('/app/sales/proforma-invoices') || location.pathname.startsWith('/app/sales/invoice-requests'))) ||
              (item.href === '/app/sales/quotations' && location.pathname.startsWith('/app/sales/quotations')) ||
              (item.href === '/app/sales/milestones' && location.pathname.startsWith('/app/sales/milestones'));
            return (
              <NavLink
                key={item.href}
                to={item.href}
                className={`flex shrink-0 items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg whitespace-nowrap transition-colors ${
                  isActive
                    ? 'bg-indigo-50 dark:bg-indigo-950/30 text-indigo-600 dark:text-indigo-400 border border-indigo-200 dark:border-indigo-800'
                    : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white'
                }`}
              >
                <Icon className="h-4 w-4 shrink-0" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}